<template>
	<div class="page career">
		<!-- career -->
		<section class="secWrap careerWrap">
			<div class="topBgWrap" :style="topBgStyle"></div>
			<div class="pageContentWrap">
				<div class="pageTitleWrap">
					<h2 class="titleTxt center" v-html="career.top.title.txt"></h2>
					<p class="subTxt center" v-html="career.top.subTxt.txt"></p>
				</div>
				<div class="pageCardBoxWrap" data-aos="fade-right">
					<div
						class="pageCardBackground cont1"
						:style="getPageCardStyle(career.pageCardBackgrounds[0])"
					>
						<p>전문성</p>
						<span
							>한걸음 앞선 기술력과<br />끊임없는 노력으로 IT 전문가로서의<br />자부심을
							갖는 사람</span
						>
						<div class="pageCardBgOverlay"></div>
					</div>
					<div
						class="pageCardBackground cont2"
						:style="getPageCardStyle(career.pageCardBackgrounds[1])"
					>
						<p>주인의식</p>
						<span
							>내가 맡은 일에 대해<br />책임감을 갖고<br />올바른 공동체 협업을
							할 수 있는 사람</span
						>
						<div class="pageCardBgOverlay"></div>
					</div>
					<div
						class="pageCardBackground cont3"
						:style="getPageCardStyle(career.pageCardBackgrounds[2])"
					>
						<p>협동심</p>
						<span
							>마주한 문제를 합리적으로 의사소통하고<br />팀원과의 방향성을<br />함께
							도모할 수 있는 사람</span
						>
						<div class="pageCardBgOverlay"></div>
					</div>
				</div>
			</div>
			<div class="midBgWrap">
				<div :style="midBgStyle">
					<p>자격 요건</p>
					<span>- 학력 : 무관(성별무관)</span>
					<span>- 경력 : 신입/경력자 지원 가능</span>
					<span
						>- 공통업무 : 생명보험/화재보험의 영업지원시스템, SFA, 홈페이지,
						다이렉트 사이트 등 채널단 업무</span
					>
					<span>- 핵심역량 : 주인의식, 성실성, 적응성, 협동심</span>
				</div>
			</div>
			<div class="pageContentWrap recruit">
				<p>모집분야</p>
				<ul class="recruitSecCol">
					<li>
						<div class="pmImg" :style="pmImgStyle"></div>
						<div class="txt">
							<p>PM</p>
							<span
								>- 담당업무 : SI프로젝트 사업 및 일정관리, 제안서 작성, 산출물
								관리</span
							>
							<span>- 스킬 : SI기획, 컨설팅, JAVA, JAVAScript</span>
							<span
								>- 우대사항 : 유관 업무 경력자, 보험영업지원시스템/SFA 유경험자,
								UI Framework(Vue.js, Websquare) 유경험자, 30억이상 프로젝트
								경험자</span
							>
						</div>
					</li>
					<li>
						<div class="devImg" :style="devImgStyle"></div>
						<div class="txt">
							<p>개발</p>
							<span
								>- 담당업무 : SI프로젝트 프론트앤드, 백앤드 개발, SM운영 및
								개발</span
							>
							<span
								>- 스킬 : HTML5, JAVA, JAVAScript, Jquery, JSP, UI
								Framework(Vue.js, Websquare)</span
							>
							<span
								>- 우대사항 : 동종업계 개발 경력자, JAVA 프로그램 능숙자, 원활한
								커뮤니케이션 가능자</span
							>
						</div>
					</li>
					<li>
						<div class="planImg" :style="planImgStyle"></div>
						<div class="txt">
							<p>기획</p>
							<span
								>- 담당업무 : 금융권 SI프로젝트 UI/UX 기획설계, 시스템 서비스
								기획, 테스트 및 관리</span
							>
							<span
								>- 스킬 : HTML5, JAVA, UI Framework(Vue.js, Websquare),
								PowerPoint</span
							>
							<span
								>- 우대사항 : 보험영업지원시스템, SFA유 경험자, 컴퓨터활용능력
								우수자, 원활한 커뮤니케이션 가능자</span
							>
						</div>
					</li>
				</ul>
			</div>
			<div class="pageContentWrap condition">
				<p>모집규모 및 근무조건</p>
				<div class="workingCondition">
					<div>
						<span class="condition icon1" :style="condition1Style"></span>
						<p>모집인원</p>
						<span>00명</span>
					</div>
					<div>
						<span class="condition icon2" :style="condition2Style"></span>
						<p>근무시간</p>
						<span>오전 9시 ~ 오후 6시</span>
					</div>
					<div>
						<span class="condition icon3" :style="condition3Style"></span>
						<p>고용형태</p>
						<span>정규직<br />(신입지원 시 수습기간 3개월)</span>
					</div>
					<div>
						<span class="condition icon4" :style="condition4Style"></span>
						<p>근무지</p>
						<span>[본사]서울 강남<br />[기타 근무지역]서울 전 지역</span>
					</div>
				</div>
				<span>채용담당자 &nbsp;&nbsp;|&nbsp;&nbsp; sjh@twosonsoft.com</span>
			</div>
		</section>
		<section class="secWrap careerBottomWrap type1" :style="bottomBgStyle">
			<b v-html="career.bottomBackground.title.txt"></b>
			<div class="pageBottomBackground" data-aos="fade-up">
				<div class="welfareCard welfare1">
					<span class="welfareImg1" :style="welfare1Style"></span>
					<h5 v-html="career.welfareCard1.title.txt"></h5>
					<p v-html="career.welfareCard1.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare2">
					<span class="welfareImg2" :style="welfare2Style"></span>
					<h5 v-html="career.welfareCard2.title.txt"></h5>
					<p v-html="career.welfareCard2.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare3">
					<span class="welfareImg3" :style="welfare3Style"></span>
					<h5 v-html="career.welfareCard3.title.txt"></h5>
					<p v-html="career.welfareCard3.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare4">
					<span class="welfareImg4" :style="welfare4Style"></span>
					<h5 v-html="career.welfareCard4.title.txt"></h5>
					<p v-html="career.welfareCard4.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare5">
					<span class="welfareImg5" :style="welfare5Style"></span>
					<h5 v-html="career.welfareCard5.title.txt"></h5>
					<p v-html="career.welfareCard5.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare6">
					<span class="welfareImg6" :style="welfare6Style"></span>
					<h5 v-html="career.welfareCard6.title.txt"></h5>
					<p v-html="career.welfareCard6.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare7">
					<span class="welfareImg7" :style="welfare7Style"></span>
					<h5 v-html="career.welfareCard7.title.txt"></h5>
					<p v-html="career.welfareCard7.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare8">
					<span class="welfareImg8" :style="welfare8Style"></span>
					<h5 v-html="career.welfareCard8.title.txt"></h5>
					<p v-html="career.welfareCard8.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare9">
					<span class="welfareImg9" :style="welfare9Style"></span>
					<h5 v-html="career.welfareCard9.title.txt"></h5>
					<p v-html="career.welfareCard9.subTxt.txt"></p>
				</div>
			</div>
		</section>
		<section class="secWrap careerBottomWrap type2" :style="bottomBgStyle">
			<b v-html="career.bottomBackground.title.txt"></b>
			<div class="pageBottomBackground" data-aos="fade-up">
				<div class="welfareCard welfare1">
					<span class="welfareImg1" :style="welfare1Style"></span>
					<h5 v-html="career.welfareCard1.title.txt"></h5>
					<p v-html="career.welfareCard1.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare2">
					<span class="welfareImg2" :style="welfare2Style"></span>
					<h5 v-html="career.welfareCard2.title.txt"></h5>
					<p v-html="career.welfareCard2.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare3">
					<span class="welfareImg3" :style="welfare3Style"></span>
					<h5 v-html="career.welfareCard3.title.txt"></h5>
					<p v-html="career.welfareCard3.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare4">
					<span class="welfareImg4" :style="welfare4Style"></span>
					<h5 v-html="career.welfareCard4.title.txt"></h5>
					<p v-html="career.welfareCard4.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare5">
					<span class="welfareImg5" :style="welfare5Style"></span>
					<h5 v-html="career.welfareCard5.title.txt"></h5>
					<p v-html="career.welfareCard5.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare6">
					<span class="welfareImg6" :style="welfare6Style"></span>
					<h5 v-html="career.welfareCard6.title.txt"></h5>
					<p v-html="career.welfareCard6.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare7">
					<span class="welfareImg7" :style="welfare7Style"></span>
					<h5 v-html="career.welfareCard7.title.txt"></h5>
					<p v-html="career.welfareCard7.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare8">
					<span class="welfareImg8" :style="welfare8Style"></span>
					<h5 v-html="career.welfareCard8.title.txt"></h5>
					<p v-html="career.welfareCard8.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare9">
					<span class="welfareImg9" :style="welfare9Style"></span>
					<h5 v-html="career.welfareCard9.title.txt"></h5>
					<p v-html="career.welfareCard9.subTxt.txt"></p>
				</div>
			</div>
		</section>
		<section class="secWrap careerBottomWrap type3" :style="bottomBgStyle">
			<b v-html="career.bottomBackground.title.txt"></b>
			<div class="pageBottomBackground" data-aos="fade-up">
				<div class="welfareCard welfare1">
					<span class="welfareImg1" :style="welfare1Style"></span>
					<h5 v-html="career.welfareCard1.title.txt"></h5>
					<p v-html="career.welfareCard1.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare2">
					<span class="welfareImg2" :style="welfare2Style"></span>
					<h5 v-html="career.welfareCard2.title.txt"></h5>
					<p v-html="career.welfareCard2.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare3">
					<span class="welfareImg3" :style="welfare3Style"></span>
					<h5 v-html="career.welfareCard3.title.txt"></h5>
					<p v-html="career.welfareCard3.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare4">
					<span class="welfareImg4" :style="welfare4Style"></span>
					<h5 v-html="career.welfareCard4.title.txt"></h5>
					<p v-html="career.welfareCard4.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare5">
					<span class="welfareImg5" :style="welfare5Style"></span>
					<h5 v-html="career.welfareCard5.title.txt"></h5>
					<p v-html="career.welfareCard5.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare6">
					<span class="welfareImg6" :style="welfare6Style"></span>
					<h5 v-html="career.welfareCard6.title.txt"></h5>
					<p v-html="career.welfareCard6.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare7">
					<span class="welfareImg7" :style="welfare7Style"></span>
					<h5 v-html="career.welfareCard7.title.txt"></h5>
					<p v-html="career.welfareCard7.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare8">
					<span class="welfareImg8" :style="welfare8Style"></span>
					<h5 v-html="career.welfareCard8.title.txt"></h5>
					<p v-html="career.welfareCard8.subTxt.txt"></p>
				</div>
				<div class="welfareCard welfare9">
					<span class="welfareImg9" :style="welfare9Style"></span>
					<h5 v-html="career.welfareCard9.title.txt"></h5>
					<p v-html="career.welfareCard9.subTxt.txt"></p>
				</div>
			</div>
		</section>
		<Footer />
	</div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";
import BtnLink from "../components/ButtonLinkPage";
import TopSubMenu from "../components/TopSubMenu";
import Footer from "../components/Footer";

export default {
	name: "Career",
	components: {
		BtnLink,
		TopSubMenu,
		Footer
	},
	watch: {
		career: {
			deep: true,
			immediate: true,
			handler() {
				console.log("The list of data has changed!");
			}
		}
	},
	data() {
		return {
			pageNum: 1,
			btnMore: true,
			career: {
				background: {
					color: "#fff",
					image: require("@/assets/images/bg-career-top@2x.jpg"),
					size: "cover",
					width: "100%"
				},
				top: {
					title: {
						txt:
							"두손소프트는 금융권 Total Solution 서비스를 제공하는<br>안정적인 강소기업입니다.",
						fontWeight: "bold"
					},
					subTxt: {
						txt:
							"IT전문가를 꿈꾸는 여러분들을 위해 적극 지원할 것이며<br>개발자들의 놀이터 안에서 저희와 함께 도전의 날개를 펼칠 인재를 기다립니다.",
						fontWeight: "normal"
					}
				},
				bottomBackground: {
					title: {
						txt:
							"두손소프트는<br>전 직원의 성장과 발전을 위해 두손을 모으겠습니다!",
						fontWeight: "bold",
						color: "#fff"
					},
					image: require("@/assets/images/bg-career-bottom@2x.jpg"),
					// height: "1163px",
					// height: "2031px",
					width: "100%",
					size: "cover",
					color: "#fff"
				},
				pageCardBackgrounds: [
					{
						image: require("@/assets/images/bg-career-card1@2x.jpg"),
						color: "#fff",
						height: "400px"
					},
					{
						image: require("@/assets/images/bg-career-card2@2x.jpg"),
						color: "#ccc",
						height: "500px"
					},
					{
						image: require("@/assets/images/bg-career-card3@2x.jpg"),
						color: "#eee",
						height: "450px"
					}
				],
				middleBackground: {
					image: require("@/assets/images/bg-career-qualifications.png")
				},
				pmImg: {
					image: require("@/assets/images/career-pmImg.png")
				},
				devImg: {
					image: require("@/assets/images/career-devImg.png")
				},
				planImg: {
					image: require("@/assets/images/career-planImg.png")
				},
				condition1: {
					image: require("@/assets/images/career-conditionIcon1.png")
				},
				condition2: {
					image: require("@/assets/images/career-conditionIcon2.png")
				},
				condition3: {
					image: require("@/assets/images/career-conditionIcon3.png")
				},
				condition4: {
					image: require("@/assets/images/career-conditionIcon4.png")
				},
				welfareCard1: {
					title: {
						txt: "올해의 주인공"
					},
					subTxt: {
						txt: "우수사원/ 표창 포상"
					},
					image: require("@/assets/images/career-welfareImg1.jpg")
				},
				welfareCard2: {
					title: {
						txt: "수고했어 오늘도"
					},
					subTxt: {
						txt: "파견근무시 격려금<br>지급"
					},
					image: require("@/assets/images/career-welfareImg2.jpg")
				},
				welfareCard3: {
					title: {
						txt: "안심귀가"
					},
					subTxt: {
						txt: "심야야근 시 택시비<br>지원"
					},
					image: require("@/assets/images/career-welfareImg3.jpg")
				},
				welfareCard4: {
					title: {
						txt: "자기개발"
					},
					subTxt: {
						txt: "관련직무 자격증<br>취득 시 상품권 증정"
					},
					image: require("@/assets/images/career-welfareImg4.jpg")
				},
				welfareCard5: {
					title: {
						txt: "따뜻한 명절"
					},
					subTxt: {
						txt: "명절 기념 선물 지급"
					},
					image: require("@/assets/images/career-welfareImg5.jpg")
				},
				welfareCard6: {
					title: {
						txt: "해피버스데이"
					},
					subTxt: {
						txt: "생일자 상품권 지급"
					},
					image: require("@/assets/images/career-welfareImg6.jpg")
				},
				welfareCard7: {
					title: {
						txt: "경조 지원"
					},
					subTxt: {
						txt: "경조사 휴가 지원 및<br>화환 제공"
					},
					image: require("@/assets/images/career-welfareImg7.jpg")
				},
				welfareCard8: {
					title: {
						txt: "열심히 일한 자<br>떠나라"
					},
					subTxt: {
						txt: "휘닉스파크(평창, 제주)<br>회원자격 이용"
					},
					image: require("@/assets/images/career-welfareImg8.jpg")
				},
				welfareCard9: {
					title: {
						txt: "두손아<br>생일축하해"
					},
					subTxt: {
						txt: "창립기념일 기념<br>선물 지급"
					},
					image: require("@/assets/images/career-welfareImg9.jpg")
				},
				list: [] // 데이터는 mounted 훅에서 불러올 예정
			}
		};
	},
	computed: {
		topBgStyle: function() {
			return {
				backgroundColor: this.career.background.color,
				backgroundImage: "url(" + this.career.background.image + ")",
				height: this.career.background.height,
				width: this.career.background.width,
				backgroundSize: this.career.background.size
					? this.career.background.size
					: "cover",
				backgroundPosition: this.career.background.position
					? this.career.background.position
					: "center center",
				backdropFilter: "blur(2.5px)",
				WebkitBackdropFilter: "blur(2.5px)"
			};
		},
		bottomBgStyle: function() {
			return {
				height: this.career.bottomBackground.height,
				width: this.career.background.width,
				backgroundImage: "url(" + this.career.bottomBackground.image + ")",
				color: this.career.bottomBackground.color
			};
		},
		midBgStyle: function() {
			return {
				backgroundImage: "url(" + this.career.middleBackground.image + ")"
			};
		},
		pmImgStyle: function() {
			return {
				backgroundImage: "url(" + this.career.pmImg.image + ")"
			};
		},
		devImgStyle: function() {
			return {
				backgroundImage: "url(" + this.career.devImg.image + ")"
			};
		},
		planImgStyle: function() {
			return {
				backgroundImage: "url(" + this.career.planImg.image + ")"
			};
		},
		condition1Style: function() {
			return {
				backgroundImage: "url(" + this.career.condition1.image + ")"
			};
		},
		condition2Style: function() {
			return {
				backgroundImage: "url(" + this.career.condition2.image + ")"
			};
		},
		condition3Style: function() {
			return {
				backgroundImage: "url(" + this.career.condition3.image + ")"
			};
		},
		condition4Style: function() {
			return {
				backgroundImage: "url(" + this.career.condition4.image + ")"
			};
		},
		welfare1Style: function() {
			return {
				backgroundImage: "url(" + this.career.welfareCard1.image + ")"
			};
		},
		welfare2Style: function() {
			return {
				backgroundImage: "url(" + this.career.welfareCard2.image + ")"
			};
		},
		welfare3Style: function() {
			return {
				backgroundImage: "url(" + this.career.welfareCard3.image + ")"
			};
		},
		welfare4Style: function() {
			return {
				backgroundImage: "url(" + this.career.welfareCard4.image + ")"
			};
		},
		welfare5Style: function() {
			return {
				backgroundImage: "url(" + this.career.welfareCard5.image + ")"
			};
		},
		welfare6Style: function() {
			return {
				backgroundImage: "url(" + this.career.welfareCard6.image + ")"
			};
		},
		welfare7Style: function() {
			return {
				backgroundImage: "url(" + this.career.welfareCard7.image + ")"
			};
		},
		welfare8Style: function() {
			return {
				backgroundImage: "url(" + this.career.welfareCard8.image + ")"
			};
		},
		welfare9Style: function() {
			return {
				backgroundImage: "url(" + this.career.welfareCard9.image + ")"
			};
		}
	},
	mounted() {
		// 데이터 로드
		this.$axios
			.post(
				this.$store.state.dataUrl +
					"/twosonBoardList?cate=news&page" +
					this.pageNum
			)
			.then(response => {
				console.log("newsList : ", response.data);
				this.career.list = response.data; // 데이터를 career.list에 할당
			})
			.catch(error => {
				console.log("* error : " + error.response);
			});

		// AOS 라이브러리 초기화
		AOS.init({
			duration: 600,
			easing: "ease-in-sine",
			delay: 100
		});
	},
	methods: {
		getPageCardStyle(background) {
			return {
				backgroundImage: `url(${background.image})`,
				backgroundSize: "cover",
				backgroundPosition: "center center"
			};
		},
		goBoardItemView(index) {
			// 클릭 이벤트 핸들러 구현
			console.log("Clicked item index:", index);
			// 클릭된 항목에 대한 처리 구현
		}
	}
};
</script>

<style lang="scss">
.page {
	.secWrap {
		.pageContentWrap {
			.pageHeaderBoxWrap {
				$pd: 40px;
				.top,
				.right,
				.bottom,
				.left {
					position: absolute;
				}
				.pageHeaderTitle {
					&.top {
						top: $pd;
					}
					&.right {
						right: $pd;
					}
					&.bottom {
						bottom: $pd;
					}
					&.left {
						left: $pd;
					}
				}
			}
		}
	}
}
</style>

<style lang="scss" scoped>
@import "@/css/variables.scss";
.page {
	position: relative;
	padding-top: 88px;
	height: auto;
	width: 100%;
	background-color: $c-white;
	.secWrap {
		position: relative;
		width: 100%;
		margin: 0 auto;
		padding: 0;
		.topBgWrap {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 284px;
			z-index: 0;
		}
		.midBgWrap {
			width: 100%;
			background-color: #f6f6f6;
			margin-bottom: 52px;
			padding: 0 28px;
			div {
				width: 1200px;
				display: flex;
				flex-direction: column;
				margin: 0 auto;
				background-repeat: no-repeat;
				background-position: right 0 center;
				padding: 62px 0;
			}
			p {
				color: #242424;
				font-family: "Noto Sans CJK KR";
				font-size: 24px;
				font-weight: 700;
				margin-bottom: 24px;
			}
			span {
				color: #464646;
				font-family: "Noto Sans CJK KR";
				font-size: 16px;
				font-weight: 400;
			}
		}
		.pageContentWrap {
			position: relative;
			margin: 0 auto;
			.pageTitleWrap {
				padding: 71px 0 123px;
				.titleTxt {
					color: $c-white;
					font-size: $title-medium;
					font-weight: bold;
					margin-bottom: 16px;
				}
				.titleTxt.center {
					text-align: center;
					font-size: 45px;
				}
				.subTxt {
					color: $c-gray-light;
					font-size: $text-normal;
				}
				.subTxt.center {
					text-align: center;
					font-size: 21px;
				}
			}
			.pageCardBoxWrap {
				display: flex;
				gap: 13.5px;
				height: 324px;
				margin-bottom: 52px;
			}

			.pageCardBackground {
				flex: 1;
				position: relative;
				height: 100%;
				border-radius: 8px;
				padding: 32px;
				p,
				span {
					position: relative;
					z-index: 10;
				}
				p {
					color: #fff;
					font-family: "Noto Sans CJK KR";
					font-size: 24px;
					font-weight: 700;
					margin-bottom: 24px;
				}
				span {
					color: #dcdcdc;
					font-family: "Noto Sans CJK KR";
					font-size: 16px;
					font-weight: 400;
					word-break: keep-all;
				}
			}

			.pageCardBackground .pageCardBgOverlay {
				border-radius: 8px;
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background: linear-gradient(
					135deg,
					#222 0%,
					rgba(18, 18, 18, 0.54) 61.5%,
					rgba(0, 0, 0, 0) 100%
				);
			}
			.recruitSecCol {
				display: flex;
				flex-direction: column;
			}

			.recruitSecCol li {
				width: 100%;
				display: flex;
				flex-direction: row;
				gap: 41px;
				div {
					background-repeat: no-repeat;
					display: flex;
					flex-direction: row;
				}
				.pmImg,
				.devImg,
				.planImg {
					width: 364px;
					height: 200px;
					background-position: center;
					border-radius: 8px;
					border: 1px solid #f6f6f6;
				}
				.txt {
					width: 100%;
					flex-direction: column;
					justify-content: center;
					gap: 14px;
					p {
						color: #222;
						font-family: "Noto Sans CJK KR";
						font-size: 18px;
						font-weight: 700;
					}
					span {
						color: #222;
						font-family: "Noto Sans CJK KR";
						font-size: 14px;
						font-weight: 400;
					}
				}
			}
		}
		.pageContentWrap.recruit,
		.pageContentWrap.condition {
			display: flex;
			flex-direction: column;
			gap: 25px;
			p {
				color: #242424;
				font-family: "Noto Sans CJK KR";
				font-size: 24px;
				font-weight: 700;
			}
			span {
				font-size: 14px;
			}
		}
		.pageContentWrap.recruit {
			margin-bottom: 52px;

			ul {
				gap: 25px;
			}
		}
		.pageContentWrap.condition {
			margin-bottom: 92px;
			.workingCondition {
				display: flex;
				flex-direction: row;
				justify-content: center;
				div {
					width: 270px;
					display: flex;
					flex-direction: column;
					align-items: center;
				}
				p {
					margin-bottom: 12px;
					color: #282a2b;
					text-align: center;
					font-family: "Noto Sans CJK KR";
					font-size: 18px;
					font-weight: 700;
				}
				span {
					color: #464646;
					text-align: center;
					font-family: "Noto Sans CJK KR";
					font-size: 14px;
					font-weight: 400;
				}
				.condition {
					display: inline-block;
					width: 72px;
					height: 76px;
					background-repeat: no-repeat;
					background-position: center;
					margin-bottom: 14px;
				}
			}
		}
	}
	.secWrap.careerWrap .topBgWrap {
		height: 354px;
		.pageTitleWrap {
			padding: 74px 0 125px !important;
		}
	}
	.secWrap.careerBottomWrap {
		height: 1163px;
		text-align: center;
		padding: 93px 0 127px;
		position: relative;
		b {
			text-align: center;
			font-family: "Noto Sans CJK KR";
			font-size: 32px;
			font-weight: 700;
		}
		.pageBottomBackground {
			width: 1026px;
			height: 100%;
			margin: 0 auto;
			position: relative;

			.welfareCard {
				display: flex;
				padding: 14px;
				align-items: flex-start;
				gap: 10px;
				border-radius: 8px;
				background-color: #fff;
				width: 176px;
				flex-direction: column;
				position: absolute;
				text-align: center;
				align-items: center;
				h5 {
					color: #003171;
					text-align: center;
					font-family: "Noto Sans CJK KR";
					font-size: 18px;
					font-weight: 700;
				}
				p {
					color: #464646;
					text-align: center;
					font-family: "Noto Sans CJK KR";
					font-size: 16px;
					font-weight: 400;
				}
				span {
					display: inline-block;
					width: 148px;
					height: 148px;
					margin-bottom: 6px;
					background-repeat: no-repeat;
				}
			}
			.welfare1 {
				top: 228px;
				left: 25px;
			}
			.welfare2 {
				top: 505px;
				left: 25px;
			}
			.welfare3 {
				top: 120px;
				left: 225px;
			}
			.welfare4 {
				top: 421px;
				left: 225px;
			}
			.welfare5 {
				top: 207px;
				left: 425px;
			}
			.welfare6 {
				top: 484px;
				left: 425px;
			}
			.welfare7 {
				top: 323px;
				left: 625px;
			}
			.welfare8 {
				top: 204px;
				left: 825px;
			}
			.welfare9 {
				top: 531px;
				left: 825px;
			}
		}
	}
	.secWrap.careerBottomWrap.type2 {
		display: none;
	}
	.secWrap.careerBottomWrap.type3 {
		display: none;
	}
}
/*
	##Device = Laptops, Desktops
	##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
	.pageCardBoxWrap {
		display: flex;
		gap: 13.5px;
		height: 334px !important;
	}

	.pageCardBackground {
		flex: 1;
		position: relative;
		height: 100%;
	}

	.pageCardBackground .pageCardBgOverlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.4); /* 예시로 설정한 오버레이 스타일 */
	}

	.page {
		.secWrap {
			.midBgWrap {
				div {
					width: 998px;
				}
			}
		}
	}
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	.page {
		.secWrap {
			.pageContentWrap {
				.pageTitleWrap {
					padding: 95px 30px 147px;
					.titleTxt.center {
						font-size: 32px;
					}
					.subTxt.center {
						text-align: center;
						font-size: 18px;
					}
				}
				.pageCardBoxWrap {
					height: 240px;
				}
			}
			.midBgWrap {
				div {
					width: 742px;
					background-size: 230px;
					background-position: right 0 bottom 0;
				}
			}
		}
		.secWrap.careerBottomWrap.type1 {
			display: none;
		}
		.secWrap.careerBottomWrap.type2 {
			display: block;
			height: 1539px;
		}
		.secWrap.careerBottomWrap {
			.pageBottomBackground {
				width: 742px;

				.welfare1 {
					top: 200px;
					left: 95px;
				}
				.welfare2 {
					top: 478px;
					left: 95px;
				}
				.welfare3 {
					top: 780px;
					left: 95px;
				}
				.welfare4 {
					top: 120px;
					left: 295px;
				}
				.welfare5 {
					top: 422px;
					left: 295px;
				}
				.welfare6 {
					top: 700px;
					left: 295px;
				}
				.welfare7 {
					top: 224px;
					left: 495px;
				}
				.welfare8 {
					top: 527px;
					left: 495px;
				}
				.welfare9 {
					top: 857px;
					left: 495px;
				}
			}
		}
	}
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
	//CSS
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 481px) and (max-width: 767px) {
	.page {
		padding-top: 52px;
		.secWrap {
			.topBgWrap {
				height: 236px;
			}
			.pageContentWrap {
				.pageTitleWrap {
					padding: 54px 20px 54px;
					.subTxt {
						font-size: $text-small;
					}
					.titleTxt {
						font-size: $title-small;
					}
					.titleTxt.center {
						font-size: 20px;
					}
					.subTxt.center {
						font-size: 14px;
					}
				}
				.pageHeaderBoxWrap {
					width: calc(100% - 40px);
					margin: 0 20px 24px;
					padding: 26px 20px;
					.pageHeaderTxt {
						max-width: 100%;
					}
					.pageHeaderTitle {
						max-width: 100%;
						font-size: $title-xxsmall;
						&.bottom {
							bottom: 26px;
						}
						&.right {
							right: 20px;
						}
					}
				}
				.seachingWrap {
					padding: 0 20px;
					margin-bottom: 21px;
				}
				.newsList {
					padding: 0 20px 40px;
					.newsItem {
						padding: 0;
						flex-wrap: wrap;
						.thumbWrap {
							width: 100%;
							height: auto;
							margin-bottom: 20px;
							.imgWrap {
								img {
									position: static;
									display: block;
									width: 100%;
									height: auto;
									max-height: 100%;
									transform: none;
								}
							}
						}
						.itemContentWrap {
							width: 100%;
							margin-left: 0;
							padding: 0 15px 55px;
							.titleTxt {
								margin-bottom: 10px;
								font-size: $title-xxsmall;
							}
							.date {
								left: 15px;
								bottom: 15px;
							}
						}
						.btnLink {
							right: 7px;
							bottom: 7px;
							&.btnLinkWrap {
								width: 40px;
								height: 40px;
							}
						}
					}
				}
			}
		}
		/* .secWrap.careerBottomWrap.type1 {
			display: none;
		}
		.secWrap.careerBottomWrap.type2 {
			display: none;
		}
		.secWrap.careerBottomWrap.type3 {
			display: block;
			height: 2031px;
		} */
		.secWrap.careerBottomWrap {
			.pageBottomBackground {
				width: 742px;

				.welfare1 {
					top: 464px;
					left: 52px;
				}
				.welfare2 {
					top: 478px;
					left: 52px;
				}
				.welfare3 {
					top: 780px;
					left: 52px;
				}
				.welfare4 {
					top: 120px;
					left: 52px;
				}
				.welfare5 {
					top: 422px;
					left: 295px;
				}
				.welfare6 {
					top: 700px;
					left: 295px;
				}
				.welfare7 {
					top: 224px;
					left: 495px;
				}
				.welfare8 {
					top: 527px;
					left: 495px;
				}
				.welfare9 {
					top: 857px;
					left: 495px;
				}
			}
		}
	}
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 767px) {
	.page {
		padding-top: 52px;
		.secWrap {
			.topBgWrap {
				height: 236px;
			}
			.midBgWrap {
				padding: 0;
				height: 254px;
				p {
					font-size: 18px;
				}
				div {
					width: 100%;
					height: 100%;
					padding: 21px;
					background-size: 160px;
					background-position: right 0 bottom 0;
					p {
						font-size: 18px;
						margin-bottom: 12px;
					}
					span {
						font-size: 12px;
					}
				}
			}
			.pageContentWrap {
				.pageTitleWrap {
					padding: 54px 20px 100px;

					.subTxt {
						font-size: $text-tiny;
					}
					.titleTxt {
						font-size: $title-small;
					}
					.titleTxt.center {
						font-size: 20px;
						width: 280px;
						word-break: keep-all;
						margin: 0 auto 24px;
					}
					.subTxt.center {
						font-size: 14px;
						word-break: keep-all;
					}
				}
				.pageCardBoxWrap {
					flex-direction: column;
					padding: 0 43.5px;
					height: 840px;
					.pageCardBackground {
						padding: 24px;
						height: 273px;
						p {
							font-size: 18px;
						}
						span {
							font-size: 12px;
						}
						.pageCardBgOverlay {
							height: 100%;
						}
					}
				}
			}
			.pageContentWrap.recruit {
				padding: 0 21px;
				p {
					font-size: 18px;
				}
				ul {
					li {
						flex-direction: column;
						align-items: center;
						margin-bottom: 32px;
						.pmImg,
						.devImg,
						.planImg {
							width: 96px;
							height: 108px;
							background-size: 96px;
						}
						.txt {
							p {
								font-size: 16.5px;
							}
							span {
								font-size: 12.5px;
							}
						}
					}
				}
			}
			.pageContentWrap.condition {
				padding: 0 21px;
				p {
					font-size: 18px;
				}
				.workingCondition {
					flex-wrap: wrap;
					div {
						width: 154px;
						height: 178px;
						margin-bottom: 10.5px;
						p {
							font-size: 13.5px;
						}
						span {
							font-size: 10.5px;
						}
					}
				}
			}
		}
		.secWrap.careerWrap {
			.topBgWrap {
				height: 276px;
			}
		}
		.secWrap.careerBottomWrap.type1 {
			display: none;
		}
		.secWrap.careerBottomWrap.type2 {
			display: none;
		}
		.secWrap.careerBottomWrap.type3 {
			display: block;
			height: 1794px;
		}
		.secWrap.careerBottomWrap {
			b {
				font-size: 20px;
				width: 239px;
				display: inline-block;
				word-break: keep-all;
			}
			.pageBottomBackground {
				width: 360px;
				.welfareCard {
					width: 156px;
					h5 {
						color: #003171;
						text-align: center;
						font-family: "Noto Sans CJK KR";
						font-size: 16px;
						font-weight: 700;
					}
					p {
						color: #464646;
						text-align: center;
						font-family: "Noto Sans CJK KR";
						font-size: 14px;
						font-weight: 400;
					}
					span {
						width: 128px;
						background-size: 128px;
					}
				}
				.welfare1 {
					top: 207px;
					left: 17px;
				}
				.welfare2 {
					top: 471px;
					left: 17px;
				}
				.welfare3 {
					top: 759px;
					left: 17px;
				}
				.welfare4 {
					top: 1048px;
					left: 17px;
				}
				.welfare5 {
					top: 100px;
					left: 187px;
				}
				.welfare6 {
					top: 365px;
					left: 187px;
				}
				.welfare7 {
					top: 631px;
					left: 187px;
				}
				.welfare8 {
					top: 920px;
					left: 187px;
				}
				.welfare9 {
					top: 1234px;
					left: 187px;
				}
			}
		}
	}
}
</style>
